import capitalize from 'underscore.string/capitalize';

import plural from 'helpers/plural';

import moment from 'moment';

angular.module('filters').filter('membershipPlanDetailedPayments', ["$rootScope", "$filter", function($rootScope, $filter) {
  return function(plan, currency, detailed) {
    var intervalUnit, recurringStartDate, repeatPayment, upfrontDate, upfrontPayment;
    upfrontPayment = $filter('currency')(plan.cost_upfront, currency);
    repeatPayment = $filter('currency')(plan.cost_repeat, currency);
    intervalUnit = plural(plan.charge_interval_unit, plan.charge_interval_number, plan.charge_interval_number > 1);
    if (detailed) {
      upfrontDate = moment(plan.upfront_payment_on).format('ll');
      recurringStartDate = moment(plan.recurring_payments_start_on).format('ll');
      if (plan.cost_repeat > 0 && plan.charge_interval_unit) {
        if (plan.cost_upfront > 0) {
          return `First payment of ${upfrontPayment} (to be taken on ${upfrontDate}) and then ${repeatPayment} every ${intervalUnit}, starting ${recurringStartDate}`;
        } else {
          return `${repeatPayment} every ${intervalUnit}, starting ${recurringStartDate}`;
        }
      } else {
        if (plan.cost_upfront > 0) {
          return `Up-front payment of ${upfrontPayment}, to be taken on ${upfrontDate}`;
        } else {
          return "Free plan";
        }
      }
    } else {
      if (plan.cost_repeat > 0 && plan.charge_interval_unit) {
        if (plan.cost_upfront > 0) {
          return `First Payment ${upfrontPayment} and then ${repeatPayment} every ${intervalUnit}`;
        } else {
          return `${repeatPayment} paid every ${intervalUnit}`;
        }
      } else {
        if (plan.cost_upfront > 0) {
          return `Up-front payment of ${upfrontPayment}`;
        } else {
          return "Free plan";
        }
      }
    }
  };
}]);
